import React from "react"
import { AppButtonIcon } from "@components"
import { CircularProgress } from "@mui/material"
import { useEditReport } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportTableEditAction({ isRunning, idReport }) {

	const { isLoading, setIsLoading } = useEditReport(idReport)

	if (isLoading) return <CircularProgress size={17} sx={{ m: 0.2 }}/>

	return !isRunning && <AppButtonIcon
		icon="pen"
		tooltip="Edit"
		onClick={setIsLoading}
	/>

}